import { WebApi } from "@/api/web";
import { ErrorMessage, Field, Form, Formik, FormikHelpers } from "formik";
import React from "react";
import * as Yup from "yup";

type PropType = {
  className?: string;
};

const Contact: React.FC<PropType> = (props) => {
  const initialValues = {
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  };

  const schema = Yup.object().shape({
    name: Yup.string().required("Informe o nome"),
    email: Yup.string().email("Informe um e-mail válido.").required("Informe o e-mail."),
    phone: Yup.string().required("Informe o telefone"),
    subject: Yup.string().required("Informe o assunto."),
    message: Yup.string().required("Informe a mensagem.").max(100, "A mensagem pode conter no máximo 100 caracteres."),
  });

  const onSubmit = async (form: any, actions: FormikHelpers<any>) => {
    actions.setSubmitting(true);
    const data = {
      name: form.name,
      email: form.email,
      phone: form.phone,
      subject: form.subject,
      message: form.message,
    } as ContactBody;

    await WebApi.contact({ ...data })
      .then(() => {
        actions.resetForm();
        actions.setStatus({ success: `${data.name.split(" ")[0]}, seu e-mail foi enviado com sucesso` });
      })
      .catch(({ response }) => {
        actions.resetForm();
        actions.setStatus({ error: response.data.message });
      });

    actions.setSubmitting(false);
  };

  return (
    <div className={`rbt-contact-address ${props.className}`}>
      <div className="container">
        <div className="row g-5">
          <div className="rbt-contact-form contact-form-style-1 max-width-auto">
            <h4 className="title">Enviar e-mail </h4>
            <Formik initialValues={initialValues} validationSchema={schema} onSubmit={onSubmit}>
              {({ status, isSubmitting }) => (
                <Form className="rainbow-dynamic-form max-width-auto">
                  <div className="bg-white rounded-lg shadow-md p-8">
                    {status && status.success && <span className="rbt-badge-6 bg-primary-opacity">{status.success}</span>}
                    {status && status.error && <span className="rbt-badge-6 bg-warning-opacity">{status.error}</span>}
                    <div className="form-group">
                      <Field name="name" placeholder="Nome" />
                      <ErrorMessage className="msg-form-error" component="div" name="name" />
                    </div>
                    <div className="form-group">
                      <Field name="email" type="email" placeholder="E-mail" />
                      <ErrorMessage className="msg-form-error" component="div" name="email" />
                    </div>
                    <div className="form-group">
                      <Field name="phone" placeholder="Telefone" />
                      <ErrorMessage className="msg-form-error" component="div" name="phone" />
                    </div>
                    <div className="form-group">
                      <Field name="subject" placeholder="Assunto" />
                      <ErrorMessage className="msg-form-error" component="div" name="subject" />
                    </div>
                    <div className="form-group">
                      <Field name="message" as="textarea" rows="8" placeholder="Mensagem" />
                      <ErrorMessage className="msg-form-error" component="div" name="message" />
                    </div>
                    <div className="form-submit-group">
                      <button name="submit" type="submit" disabled={isSubmitting} className="rbt-btn btn-secondary btn-md w-100">
                        <span className="btn-text">Enviar</span>
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
